import { PartialTranslation } from '../translations';

export const ru: PartialTranslation = {
  newChat: 'Новый чат',
  search: 'Поиск',
  user: 'Пользователь',
  settings: 'Настройки',
  language: 'Язык',
  getHelp: 'Получить помощь',
  viewAllPlans: 'Посмотреть все планы',
  learnMore: 'Узнать больше',
  logOut: 'Выйти',
  chooseLanguage: 'Выбрать Язык',
  chooseYourPreferredLanguage: 'Выберите предпочитаемый язык',
  searchLanguages: 'Поиск языков...',
  autoDetect: 'Автоматическое определение',
  noLanguagesFound: 'Языки не найдены',
  askAnything: 'Спросите что угодно',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Личный',
  freePlan: 'Бесплатный план',
  current: 'Текущий',
  close: 'Закрыть',
  archive: 'Архивировать',
  delete: 'Удалить',
  confirmDelete: 'Вы уверены, что хотите удалить этот чат?',
  confirmArchive: 'Вы уверены, что хотите архивировать этот чат?',
  deleteCannotUndo: 'Это действие нельзя отменить.',
  archiveCanFind: 'Вы можете найти его в списке архивов после архивирования.',
  
  // 资源面板
  resources: 'Ресурсы',
  addResource: 'Добавить ресурс',
  deleteResource: 'Удалить ресурс',
  noMatchingResourcesFound: 'Подходящие ресурсы не найдены',
  noResourcesAvailable: 'Нет доступных ресурсов',
  hideResources: 'Скрыть ресурсы',
  showResources: 'Показать ресурсы',
  
  // 聊天输入框
  typeMessage: 'Введите сообщение...',
  thinkingOptions: 'Варианты мышления',
  deleteFile: 'Удалить файл',
  clearSelection: 'Очистить выбор',
  addAttachment: 'Добавить вложение',
  sendMessage: 'Отправить сообщение',
  
  // 思考模式选项
  deepInsight: 'Глубокое Понимание · Поверхностный Анализ',
  deepInsightDesc: 'Быстрое понимание ключевых моментов',
  deepExploration: 'Глубокое Исследование · Комплексный Анализ',
  deepExplorationDesc: 'Многомерное углубленное исследование',
  deepDeconstruction: 'Глубокая Деконструкция · Систематическая Аргументация',
  deepDeconstructionDesc: 'Поэтапный прогрессивный анализ',
  
  // 写作模式选项
  contractReview: 'Проверка Контракта · Выявление Рисков',
  contractReviewDesc: 'Анализ пунктов и проверка соответствия',
  textPolish: 'Полировка Текста · Профессиональное Выражение',
  textPolishDesc: 'Языковая оптимизация и структурная корректировка',
  legalDocuments: 'Юридические Документы · Стандартное Составление',
  legalDocumentsDesc: 'Профессиональное составление юридических документов',

  // 认证和隐私翻译
  login: 'Войти',
  register: 'Регистрация',
  welcomeBack: 'Добро пожаловать в LawHelper',
  loginSubtitle: 'Ваш ИИ-помощник по правовым исследованиям',
  continueWithGoogle: 'Продолжить с Google',
  continueWithMicrosoft: 'Продолжить с Microsoft',
  continueWithWeChat: 'Продолжить с WeChat',
  orContinueWith: 'или продолжить с',
  emailTab: 'Эл. почта',
  phoneTab: 'Телефон',
  emailPlaceholder: 'Введите вашу почту',
  phonePlaceholder: 'Введите номер телефона',
  codePlaceholder: 'Введите 6-значный код',
  sending: 'Отправка...',
  verifying: 'Проверка...',
  verify: 'Подтвердить',
  sendMagicLink: 'Отправить магическую ссылку',
  getVerificationCode: 'Получить код',
  resendCode: 'Отправить код повторно',
  resendIn: 'Отправить повторно через',
  magicLinkSent: 'Магическая ссылка отправлена на вашу почту',
  magicLinkHint: 'Мы отправим безопасную ссылку на вашу почту',
  otpSent: 'Код подтверждения отправлен',
  agreeToTerms: 'Продолжая, вы соглашаетесь с нашими',
  privacyPolicy: 'Политика конфиденциальности',
  termsOfService: 'Условия использования',
  and: 'и',
  privacyTitle: 'Ваша конфиденциальность важна',
  privacyIntro: 'Мы используем файлы cookie и аналогичные технологии для обеспечения лучшего опыта.',
  essentialCookies: 'Необходимые cookie',
  essentialDesc: 'Требуются для работы сайта',
  analyticsCookies: 'Аналитические cookie',
  analyticsDesc: 'Помогают нам улучшать сервис',
  marketingCookies: 'Маркетинговые cookie',
  marketingDesc: 'Используются для персонализированного контента',
  acceptAll: 'Принять все',
  essentialOnly: 'Только необходимые',
  customize: 'Настроить',
  savePreferences: 'Сохранить настройки',
  back: 'Назад',
  readPrivacyPolicy: 'Читать политику конфиденциальности',
  cookiePolicy: 'Политика cookie',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'ИИ Проверка',
  aiDraft: 'ИИ Черновик',
  smartAssistant: 'Шаблон',

  // 知识库搜索
  enableKnowledgeSearch: 'Включить поиск',
  knowledgeSearchDesc: 'ИИ ищет в ваших документах',
  clickToDisable: 'Отключить',
  clickToEnable: 'Включить',

  // Landing page translations
  tagline: 'Юридический ИИ',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Упрощённо.',
  jurisdictionsLabel: 'Юрисдикции',
  accuracyLabel: 'Точность',
  fasterLabel: 'Быстрее',
  availableLabel: 'Доступно',
  platformCapabilities: 'Возможности',
  testimonialQuote: '"LawHelper изменил нашу работу."',
  testimonialAuthor: 'Юрист',
  testimonialPosition: 'Партнёр',
  viewPricing: 'Цены',
  footerPricing: 'Цены',
  footerPrivacy: 'Конфиденциальность',
  footerTerms: 'Условия',
  footerContact: 'Контакты',
  footerCopyright: '© 2024 LawHelper.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Закрыть панель ресурсов',
  uploading: 'Загрузка %{fileName}...',
  processing: 'Обработка %{fileName}...',
  uploadSuccess: '✓ %{fileName} загружен',
  uploadError: '✗ Ошибка загрузки: %{error}',
  quickAnswer: 'Быстрый ответ',
  quickAnswerDesc: 'Быстрый ответ на простые вопросы',
  cancelRequest: 'Отмена',
  library: 'Библиотека',
  filterAll: 'Все',
  filterChat: 'Чаты',
  filterReview: 'Проверка',
  filterDraft: 'Черновик',
  filterTemplate: 'Шаблон',
  filterForm: 'Форма',
  thinking: 'Думаю...',
  thinkingProcess: 'Процесс мышления',
  analyzingLegalLogic: 'Анализ юридической логики...',
  lawhelperThinking: 'Lawhelper думает...',
  serviceError: 'Ошибка сервиса',
  uploaded: 'Загружено',
  settingsGeneral: 'Общие',
  settingsNotifications: 'Уведомления',
  settingsAppearance: 'Внешний вид',
  settingsProfile: 'Профиль',
  settingsResponseNotifications: 'Уведомления об ответах',
  settingsResponseNotificationsDesc: 'Уведомление при завершении ответа ИИ',
  settingsColorMode: 'Цветовой режим',
  settingsLight: 'Светлый',
  settingsDark: 'Тёмный',
  settingsSystem: 'Системный',
  about: 'О программе',
  reviewTitle: 'Проверка документа',
  exitReview: 'Выйти из проверки',
  uploadPrompt: 'Загрузите PDF для проверки',
  uploadButton: 'Выбрать файл',
  startChatConfig: 'Введите "Проверить документ" для начала',
  reviewPlaceholder: 'Введите сообщение или "Проверить документ"...',
  analyzing: 'Проверка...',
  reviewComplete: 'Проверка завершена',
  issuesFound: 'Найдено %{count} проблем',
  draftTitle: 'Составление юридического документа',
  draftPlaceholder: 'Редактируйте здесь или попросите ИИ сгенерировать...',
  analyzingTemplate: 'Анализ шаблона %{name}...',
  templateAnalyzed: '✅ Шаблон %{name} проанализирован! Укажите, как его изменить.',
  templateAnalysisPrompt: 'Проанализировать ключевые пункты шаблона',
  parsingFailed: '⚠️ Не удалось разобрать файл, но вы можете описать свои требования.',
  generating: 'Генерация...',
  generatedSuccess: '✅ Документ создан! Просмотрите и отредактируйте в редакторе.',
  drafterWelcome: 'Добро пожаловать в ИИ-помощник документов',
  drafterYouCan: 'Вы можете:',
  drafterUploadTemplate: 'Загрузить шаблон для анализа ИИ',
  drafterDescribeNeeds: 'Описать требования к документу',
  drafterLetAiHelp: 'ИИ поможет составить договоры, соглашения и т.д.',
  drafterExamples: 'Примеры:',
  drafterExampleRental: '"Составьте договор аренды"',
  drafterExampleLabor: '"Заполните трудовой договор по шаблону"',
  drafterInputPlaceholder: 'Опишите ваши требования к документу...',
  drafterThinking: 'Думаю...',
  drafterHistoryTitle: 'История',
  drafterNoHistory: 'Нет истории',
  drafterNewChat: 'Новый чат',
  drafterHistory: 'История',
  drafterRemoveAttachment: 'Удалить вложение',
  drafterLineHeight: 'Межстрочный интервал',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Экспорт в Word (.docx)',
  drafterExportPdf: 'Экспорт в PDF',
  drafterSave: 'Сохранить документ',
  drafterDownload: 'Скачать документ',
  drafterUndo: 'Отменить',
  drafterRedo: 'Повторить',
  drafterBold: 'Жирный',
  drafterItalic: 'Курсив',
  drafterStrike: 'Зачёркнутый',
  drafterUnderline: 'Подчёркнутый',
  drafterHighlight: 'Выделить',
  drafterLink: 'Вставить ссылку',
  drafterAlignLeft: 'По левому краю',
  drafterAlignCenter: 'По центру',
  drafterAlignRight: 'По правому краю',
  drafterAlignJustify: 'По ширине',
  drafterList: 'Список',
  drafterBulletList: 'Маркированный список',
  drafterOrderedList: 'Нумерованный список',
  drafterTaskList: 'Список задач',
  drafterOpenResource: 'Открыть панель ресурсов',
  drafterStopGeneration: 'Остановить генерацию',
  drafterAgentMode: 'Режим Агента | Нажмите для обычного чата',
  drafterAgentModeOn: 'Режим Агента | Нажмите для обычного чата',
  drafterAgentModeOff: 'Обычный режим | Нажмите для режима Агента',
  drafterUploadAttachment: 'Загрузить вложение',
  drafterExit: 'Выход',
  drafterConfirm: 'Подтвердить',
  drafterOpenLink: 'Открыть ссылку',
  drafterDeleteLink: 'Удалить ссылку',
  drafterQuote: 'Цитата',
  workflowTitle: 'ИИ-процесс',
  workflowRunning: 'Выполняется...',
  workflowReady: 'Готов',
  workflowCompleted: 'Завершён',
  workflowStartFailed: 'Не удалось запустить процесс',
  workflowExecutionFailed: 'Ошибка выполнения процесса',
  workflowInterrupted: 'Процесс прерван',
  workflowProcessing: 'Обработка...',
  workflowStepsCompleted: 'шагов завершено',
  workflowStepsTotal: 'Процесс завершён (%{count} шагов)',
  acceptChanges: 'Принять изменения',
  rejectChanges: 'Отклонить изменения',
  changesAccepted: 'Изменения приняты',
  changesRejected: 'Изменения отклонены',
  stopWorkflow: 'Стоп',
  restartWorkflow: 'Перезапуск',
  startDrafting: 'Начать составление',
  interrupt: 'Стоп',
  documentSubject: 'Тема документа *',
  documentType: 'Тип документа',
  jurisdiction: 'Юрисдикция',
  specialRequirements: 'Особые требования (необязательно)',
  clickStartDrafting: 'Нажмите "Начать составление" для запуска процесса',
  docTypeContract: 'Договор',
  docTypeAgreement: 'Соглашение',
  docTypeNotice: 'Уведомление',
  docTypeLetter: 'Письмо',
  docTypePetition: 'Ходатайство',
  docTypeWill: 'Завещание',
  docTypePowerOfAttorney: 'Доверенность',
  countryChina: 'Китай',
  countryUSA: 'США',
  countryGermany: 'Германия',
  countryJapan: 'Япония',
  countryFrance: 'Франция',
  countryUK: 'Великобритания',
  citationVerified: 'Подтверждено',
  citationUnverified: 'Не подтверждено',
  imageLoadFailed: 'Не удалось загрузить изображение',
  smartDocTitle: 'Умный помощник документов',
  smartDocChatTitle: 'ИИ-помощник документов',
  smartDocDropPrompt: 'Перетащите PDF сюда',
  smartDocSelectFile: 'Выбрать файл',
  smartDocOr: 'или',
  smartDocWelcomeTitle: 'Добро пожаловать в ИИ-помощник документов',
  smartDocWelcomeYouCan: 'Вы можете:',
  smartDocUploadForAI: 'Загрузить шаблон для анализа',
  smartDocDescribeDoc: 'Описать требования к документу',
  smartDocLetAIDraft: 'ИИ поможет составить договоры',
  smartDocExamples: 'Примеры:',
  smartDocExampleRental: '"Составьте договор аренды"',
  smartDocExampleLabor: '"Заполните трудовой договор"',
  smartDocInputPlaceholder: 'Опишите требования к документу...',
  smartDocRemoveAttachment: 'Удалить вложение',
  smartDocOpenResources: 'Открыть панель ресурсов',
  smartDocExit: 'Выход',
  reviewStartFailed: 'Не удалось запустить проверку',
  reviewFailed: 'Проверка не удалась',
  reviewFoundIssues: 'Проверка завершена, найдено %{count} проблем.',
  cannotReadStream: 'Невозможно прочитать поток ответа',
  parseEventFailed: 'Ошибка разбора события',
  errorPrefix: 'Ошибка',
  unknownError: 'Неизвестная ошибка',
  file: 'Файл',
  loading: 'Загрузка...',
  localFolders: 'Локальные папки',
  selectLocalFolder: 'Выбрать локальную папку',
  reselectFolder: 'Сменить папку',
  addToContext: 'Добавить в чат',
  saveFile: 'Сохранить',
  renameFile: 'Переименовать',
  fileSaved: 'Файл сохранён',
  fileRenamed: 'Файл переименован в %{name}',
  browserNotSupported: 'Ваш браузер не поддерживает доступ к локальным папкам',
  noFolderSelected: 'Выберите локальную папку для просмотра файлов',
  scanningFolder: 'Сканирование папки...',
  selectFileToPreview: 'Выберите файл для предпросмотра',
  aiAnalyze: 'ИИ-анализ',
};
